@if(modalService.welcomeModal()){

<!-- Scrim (sm+ only) -->
<div
  class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[10009] transition-opacity"
  (click)="closeModal()"
></div>

<!-- Simple dialog-->
<div
  animate.enter="animate-enter-medium-up"
  animate.leave="animate-leave-medium-up"
  class="fixed inset-0 z-[10010] flex flex-col justify-center items-stretch bg-white p-safe dark:bg-gray-700 self-center m-auto min-w-72 max-w-[min(560px,100%-32px)] -max-h-svh-safe-offset-16 rounded-3xl"
>
  <!-- Scrollable body -->
  <div
    class="flex-1 min-h-0 flex flex-col justify-center gap-6 overflow-y-scroll p-6"
  >
    <!-- Logo -->
    <div class="flex flex-col items-center gap-4 transition-none">
      <div class="w-40 sm:w-48">
        <img
          src="/assets/svg/LIQ_DDA_white.svg"
          alt="Irrigation Management Logo"
          class="dark:hidden w-full aspect-auto self-center"
        />
        <img
          src="/assets/svg/LIQ_DDA_dark.svg"
          alt="Irrigation Management Logo"
          class="hidden dark:block w-full aspect-auto self-center"
        />
      </div>
      <h3
        class="text-center text-xl sm:text-2xl font-semibold text-zinc-900 dark:text-indigo-50"
      >
        Welcome to Irrigation Management
      </h3>
    </div>
    <!-- Content-->
    <div class="flex flex-col items-center gap-6">
      <div
        class="text-sm sm:text-base text-zinc-900 dark:text-indigo-50 text-center"
      >
        We're excited to have you here!
      </div>

      @if (hasSignupDefaultResource.value()) {
      <h3
        class="text-sm sm:text-base text-zinc-900 dark:text-indigo-50 text-center"
      >
        To keep you informed, you've been enrolled in our email newsletter.
      </h3>
      <div
        class="text-center text-xs sm:text-sm text-zinc-500 dark:text-slate-400"
      >
        You can unsubscribe or change this anytime in Email Preferences.
      </div>
      } @else if (!hasSignupDefaultResource.isLoading()) {
      <!-- Not auto-enrolled, but topics are available to opt into. Guarded by
           !isLoading() so enrolled users don't flash this while the check runs. -->
      <div
        class="text-center text-xs sm:text-sm text-zinc-500 dark:text-slate-400"
      >
        If you're interested in subscribing to our newsletters, go to Email
        Preferences.
      </div>
      }
      <!-- Always show a dismiss action; the email-prefs shortcut shows for both
           the auto-enrolled and the "interested in subscribing" cases, i.e.
           once the signup-default check has resolved. -->
      <div class="flex flex-col items-stretch gap-3 w-full">
        <button
          (click)="closeModal()"
          class="rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-blue-600 dark:hover:bg-blue-700"
        >
          Let's get started
          <!-- Grower/entity always have email topics, so the no-topics variant
               below never renders. Kept for reference. -->
          <!-- @if (hasSignupDefaultResource.value()) { Sounds Good } @else { Let's
          get started } -->
        </button>
        @if (!hasSignupDefaultResource.isLoading()) {
        <button
          (click)="openEmailPreferences()"
          class="rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed border border-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 dark:border-gray-600"
        >
          Manage Email Preferences
        </button>
        }
      </div>
    </div>
  </div>
</div>
}
